// Paleta de colores "de serie": son los filamentos con los que trabajamos.
// Única fuente de verdad — la consumen el ColorPicker del editor y el modal
// de solicitud de pedido (que mapea los colores del SVG contra esta gama).

// #000000 está reservado como color de vaciado/bajo relieve.
// En el pipeline 3D las formas con este color entran en la diferencia booleana
// pero no generan objeto de relleno, produciendo un efecto de tallado/grabado.
export const VACIADO_COLOR = '#000000';

export const PALETTE = [
    { value: '#000001', description: 'Black' },
    { value: '#FFFFFF', description: 'White' },
    { value: '#808080', description: 'Gray' },
    { value: '#FFFFF0', description: 'Ivory' },
    { value: '#00FF80', description: 'Turquoise' },
    { value: '#00FF00', description: 'Green' },
    { value: '#7CFC00', description: 'Lawn Green' },
    { value: '#2E8B57', description: 'Sea Green' },
    { value: '#00FA9A', description: 'Medium Spring Green' },
    { value: '#008000', description: 'Lime' },
    { value: '#00FFFF', description: 'Cyan' },
    { value: '#008080', description: 'Teal' },
    { value: '#0000FF', description: 'Blue' },
    { value: '#000080', description: 'Navy' },
    { value: '#FFC0CB', description: 'Pink' },
    { value: '#FF00FF', description: 'Magenta' },
    { value: '#9370DB', description: 'Medium Purple' },
    { value: '#800080', description: 'Purple' },
    { value: '#8A2BE2', description: 'Blue Violet' },
    { value: '#FFFF00', description: 'Yellow' },
    { value: '#DAA520', description: 'Goldenrod' },
    { value: '#f9cfab', description: 'Salmon' },
    { value: '#FFD700', description: 'Gold' },
    { value: '#FFA500', description: 'Orange' },
    { value: '#A52A2A', description: 'Brown' },
    { value: '#800000', description: 'Maroon' },
    { value: '#800000', description: 'Burgundy' },
    { value: '#FF0000', description: 'Red' },
    { value: '#FF6347', description: 'Tomato' },
    { value: '#FF4500', description: 'Orange Red' },
    { value: '#8B4513', description: 'Saddle Brown' },
];

function hexToRgb(hex) {
    const clean = hex.replace('#', '');
    const num = parseInt(clean, 16);
    return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
}

// Mapea un color cualquiera del SVG al más cercano de la paleta (distancia
// RGB euclídea). Devuelve la entrada de paleta `{ value, description }`.
export function mapToPaletteColor(hex) {
    const normalized = String(hex || '').toLowerCase();
    const exact = PALETTE.find((c) => c.value.toLowerCase() === normalized);
    if (exact) return exact;

    if (!/^#[0-9a-f]{6}$/.test(normalized)) return null;

    const [r, g, b] = hexToRgb(normalized);
    let best = null;
    let bestDistance = Infinity;
    for (const entry of PALETTE) {
        const [pr, pg, pb] = hexToRgb(entry.value);
        const distance = (r - pr) ** 2 + (g - pg) ** 2 + (b - pb) ** 2;
        if (distance < bestDistance) {
            bestDistance = distance;
            best = entry;
        }
    }
    return best;
}
